import * as React from "react"
import { useEffect } from "react";
import {Grid} from "@mui/material";

import {HOME_ROUTES, SHARE_OF_SEARCH_ROUTES} from "@constants";
import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy} from "@signals";
import PageWrapper from "Pages/@PageWrapper"
import { TourProvider, TourTarget } from "@tour"
import KeywordFilters from "./Filters";
import { isEmpty, evolutionDataFilters, resetShareOfSearchDetailsSignals, dataDetails } from './@signals'
import { ShareOfSearchKeywordTable, ShareOfSearchKeyworEvolutionChart, ShareofSearchPercentageChart } from "./@components";

const HEIGHT = 200


export default function ShareOfSearchPage() {

    const LIMIT_SEARCHES = [{
        title: "Warning Filters",
        message: 'Results are limited to 1,000. Please refine your filters for better accuracy.',
        severity: 'warning'
    }]

    const props = {
        head: `DIP Insight | ${SHARE_OF_SEARCH_ROUTES.DETAILS_TITLE}`,
        title: SHARE_OF_SEARCH_ROUTES.DETAILS_TITLE,
        subtitle: SHARE_OF_SEARCH_ROUTES.DETAILS_SUBTITLE,
        isEmpty: isEmpty.value,
        globalMessages: dataDetails.value.length === 1000 && LIMIT_SEARCHES,
        hasErrors: isSystemBusy.value
    }

    useEffect(() => {
        return () => resetShareOfSearchDetailsSignals()
    },[])

    return <PageWrapper {...props} tourPageKey="sosDetails" filters={<KeywordFilters section={false}  />}>
        <Grid container spacing={4} sx={{ pt: 6 }}>
            <Grid item xs={12} data-tour="sos-details-share-chart">
                <ShareofSearchPercentageChart sx={{ minHeight: HEIGHT }} title={'Share Of Brands'} />
            </Grid>
            <Grid item xs={12} id='table-details' sx={{ position: "relative" }}>
                <TourTarget name="sos-details-table" height={350} />
                <ShareOfSearchKeywordTable title={SHARE_OF_SEARCH_ROUTES.DETAILS_TITLE} section={false} />
            </Grid>
            <Grid item xs={12}>
                <ShareOfSearchKeyworEvolutionChart />
            </Grid>
        </Grid>
    </PageWrapper>
}